import { render } from "./CusOrderDialog.vue?vue&type=template&id=44ddb12b&scoped=true"
import script from "./CusOrderDialog.vue?vue&type=script&lang=js"
export * from "./CusOrderDialog.vue?vue&type=script&lang=js"

import "./CusOrderDialog.vue?vue&type=style&index=0&id=44ddb12b&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ddb12b"]])

export default __exports__